/**
 * Classes Tailwind de cada tom de acento dos painéis (ver `PanelTone`), num
 * lugar só: o trilho, as abas e os chips da folha pintam a camada ligada com
 * a mesma cor. Strings inteiras, e não montadas — o Tailwind só gera as
 * classes que encontra escritas por extenso.
 */
import type { PanelTone } from './panels';

export const DEFAULT_TONE: PanelTone = 'mata';

/** Ícone com a camada ligada. */
export const TONE_ICON: Record<PanelTone, string> = {
  mata: 'text-mata-300',
  fogo: 'text-fogo-400',
  rio: 'text-rio-300',
};

/** Chip da folha (celular) com a camada ligada. */
export const TONE_CHIP: Record<PanelTone, string> = {
  mata: 'border-mata-400/50 bg-mata-500/20 text-mata-300',
  fogo: 'border-fogo-400/50 bg-fogo-500/15 text-fogo-400',
  rio: 'border-rio-300/50 bg-rio-500/15 text-rio-300',
};

/** Barra lateral do trilho quando o painel desta camada está aberto. */
export const TONE_BAR: Record<PanelTone, string> = {
  mata: 'bg-mata-400',
  fogo: 'bg-fogo-400',
  rio: 'bg-rio-300',
};

/**
 * Botão do trilho de camadas do celular com a camada ligada: o fundo tingido
 * e o filete no tom da camada, como o chip da folha (`TONE_CHIP`), por dentro
 * do botão (o trilho não tem espaço para a borda crescer).
 */
export const TONE_TRILHO: Record<PanelTone, string> = {
  mata: 'bg-mata-500/25 text-mata-300 ring-1 ring-inset ring-mata-400/50',
  fogo: 'bg-fogo-500/20 text-fogo-400 ring-1 ring-inset ring-fogo-400/50',
  rio: 'bg-rio-500/20 text-rio-300 ring-1 ring-inset ring-rio-300/50',
};
